<template>
  <el-select
    v-model="selectedUser"
    remote
    :remote-method="getUserOptions"
    filterable
    clearable
    placeholder="请选择用户"
    v-bind="$attrs"
    @change="handleChange"
  >
    <el-option v-for="{label,value} in userOptions" :label="label" :value="value" :key="value" />
  </el-select>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getUserList } from '@/api/personnel-management/index.js'

const userOptions = ref([])
const selectedUser = defineModel()
const $emits = defineEmits(['change'])

onMounted(() => {
  getUserOptions()
})

async function getUserOptions(query) {
  const params = {
    page: 1,
    size: 100,
    name: query
  }
  const { result } = await getUserList(params)
  if (result) {
    userOptions.value = result.data.rows.map(item => {
      return {
        label: item.name,
        value: item.id
      }
    })
  }
}

function handleChange() {
  $emits('change')
}
</script>

<style scoped lang="scss">

</style>